module.exports = __webpack_public_path__ + "static/media/ring_green.2448544b.png";